module.exports = "/_next/static/images/Logo 2-34909d425721f86e6d29e3ec006aa5c4.png";